export default __webpack_public_path__ + "static/media/mozart6.64eb86d3.png";